// ErrorState — error message + retry for failed data fetches (Frontend Rules
// §12: every data-fetching component handles the error state).
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlertTriangleIcon } from '../../icons/Icons';
import './error-state.css';

export function ErrorState({ title, message, onRetry }) {
  const { t } = useTranslation();
  // `message` defaults to the generic copy; pass `message={null}` to suppress it.
  const resolvedMessage = message === undefined ? t('reusable.errorState.message') : message;
  return (
    <div className="error-state" role="alert">
      <span className="error-state__icon">
        <AlertTriangleIcon />
      </span>
      <p className="error-state__title">{title ?? t('reusable.errorState.title')}</p>
      {resolvedMessage && <p className="error-state__message">{resolvedMessage}</p>}
      {onRetry && (
        <button type="button" className="error-state__retry" onClick={onRetry}>
          {t('reusable.errorState.retry')}
        </button>
      )}
    </div>
  );
}

ErrorState.propTypes = {
  title: PropTypes.node,
  message: PropTypes.node,
  onRetry: PropTypes.func,
};

export default ErrorState;
